import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/dictionariesType",
    name: "dictionariesType",
    component: dashboard,
    redirect: {
      name: "categoryIndex"
    },
    children: [
      {
        path: "categoryIndex",
        name: "categoryIndex",
        meta: { title: "二维码分类配置" },
        component: () =>
          import("@/views/dictionaries/dictionariesCategory.vue"),
        children: [
          {
            path: "editDictionariesCategoryInfo/:applicationCategoryId",
            name: "editDictionariesCategoryInfo",
            meta: { title: "编辑应用分类" },
            component: () =>
              import("@/views/dictionaries/dictionariesCategoryManage.vue")
          },
          {
            path: "addDictionariesCategory",
            name: "addDictionariesCategory",
            meta: { title: "添加应用分类" },
            component: () =>
              import("@/views/dictionaries/addDictionariesCategory.vue")
          }
        ]
      }
    ]
  }
];
